export * from './aufgabenCommand.service';
import { AufgabenCommandService } from './aufgabenCommand.service';
export * from './checklisteCommand.service';
import { ChecklisteCommandService } from './checklisteCommand.service';
export * from './checklisteQuery.service';
import { ChecklisteQueryService } from './checklisteQuery.service';
export * from './dokumentCommand.service';
import { DokumentCommandService } from './dokumentCommand.service';
export * from './dokumentQuery.service';
import { DokumentQueryService } from './dokumentQuery.service';
export * from './vorlagenCommand.service';
import { VorlagenCommandService } from './vorlagenCommand.service';
export * from './vorlagenQuery.service';
import { VorlagenQueryService } from './vorlagenQuery.service';
export * from './vorlagenReporting.service';
import { VorlagenReportingService } from './vorlagenReporting.service';
export * from './vorlagenTemplates.service';
import { VorlagenTemplatesService } from './vorlagenTemplates.service';
export const APIS = [AufgabenCommandService, ChecklisteCommandService, ChecklisteQueryService, DokumentCommandService, DokumentQueryService, VorlagenCommandService, VorlagenQueryService, VorlagenReportingService, VorlagenTemplatesService];
